import { z } from "zod";

export const updateNotificationPreferencesSchema = z
	.object({
		push_enabled: z.boolean().optional(),
		email_enabled: z.boolean().optional(),
		new_content_push_enabled: z.boolean().optional(),
	})
	.strict();

export type UpdateNotificationPreferencesPayload = z.infer<typeof updateNotificationPreferencesSchema>;
